import { render, staticRenderFns } from "./CheckBoxDesigner.vue?vue&type=template&id=2aa2fb0d&scoped=true&"
import script from "./CheckBoxDesigner.vue?vue&type=script&lang=js&"
export * from "./CheckBoxDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa2fb0d",
  null
  
)

export default component.exports